import lang from "element-ui/lib/locale/lang/zh-CN"; // 引入element语言包
const messages = {
  极兔开放平台: "极兔开放平台",
  帮助中心: "帮助中心",
  "注 册": "注 册",
  快递轨迹查询: "快递轨迹查询",
  新增订单: "新增订单",
  取消订单: "取消订单",
  查询订单: "查询订单",
  打印订单: "打印订单",
  "物流轨迹订阅（新）": "物流轨迹订阅（新）",
  物流轨迹回传: "物流轨迹回传",
  订单状态回传: "订单状态回传",
  退回件申请: "退回件申请",
  indexPage: {
    title: "云仓服务技术对接平台",
    BannerTxt:
      "共享极兔云仓各类服务接口,帮助企业高效完成出入库作业、状态回传，提供库存查询、轨迹查询等服务。",
    BannerBtnTxt: "加入极兔开放平台"
  },
  apiService: {
    titleleft: "入库仓储",
    textLeft1: "新增入库单",
    textLeft2: "了解入库状态和库存",
    titleRight: "出库管理",
    textRight1: "新增出库单",
    textRight2: "了解出库状态和物流轨迹"
  },
  helpCenter: {
    电商平台列表:'电商平台列表',
    来源平台:'来源平台',
    平台代码:"平台代码",
    描述: "描述",
    虾皮:'虾皮',
    来赞达:'来赞达',
    京东印尼站:'京东印尼站',
    京东泰国站:'京东泰国站',
    Shopify独立站:'Shopify独立站',
    Shopline独立站:'Shopline独立站',
    速卖通:'速卖通',
    敦煌网:'敦煌网',
    希音:'希音',
    沃尔玛:'沃尔玛',
    UEESHOP独立站:'UEESHOP独立站',
    SHOPLAZZA独立站:'SHOPLAZZA独立站',
    亚马逊:'亚马逊',
    非上述平台:"非上述平台",
    carrier_des:'出库单创建接口中carrier承运商参数可参考此页枚举传值',
    country_des:"出库单创建接口中countrycode和pricecurrency可参考此页枚举传值",
    错误码: "错误码",
    接入指南: "接入指南",
    "国家/币种编码": "国家/币种编码",
    承运商映射: "承运商映射",
    WMS承运商编码: "WMS承运商编码",
    简称: "简称",
    method_1:
      "1. 使用http协议表单提交的方式进行信息交互，字符编码默认统一采用UTF-8，数据格式：application/x-www-form-urlencoded;",
    method_2:
      "2. apiAccount和privateKey由平台提供； digest=base64(md5(业务参数的Json+privateKey))，注：先md5得到字节数组，再将字节数组转十六进制小写字符串，再base64加密;",
    method_3:
      "3. 例如：base64(MD5({“age”:18,”gender”:”male”,”name”:”张三”}123456)) 如签名错误，可以对url进行编码然后发送请求。",
    method_4:
      "4. 字段类型约定：需要严格依据字段表格中给出的参数格式和大小进行开发。",
    method_5:
      "5. 字段解析约定：参数字段中的必选字段是每次调用接口时都要求必须传入的；",
    method_6: "6. 部分接口示例代码和sdk请参考示例代码、SDK文档。",
    业务参数签名: "业务参数签名",
    请输入加密后的32位pwd: "请输入加密后的32位pwd",
    获取: "获取",
    Headers签名: "Headers签名",
    bussness: `示例：在调用下单、取消订单等接口时，需要业务参数<code>digest</code>，而业务参数<code>digest</code>跟全局Headers里面的<code>digest</code>含义不一样。`,
    bussness_1: `首先，极兔会分配一个协议客户下单所需的账号和密码。例如：<code>J0086024071</code>/<code>BaMCAx11</code>,其中<code>pwd</code>等于<code>MD5(明文密码(BaMCAx11)+jadada236t2)</code>
    后大写,比如此示例生成的32位<code>pwd</code>为<code>A023DEEDCE52B0FD92A3EE1E9F74FD2B</code>,最后按照规则Base64(Md5(客户编号+密文+privateKey))生成业务参数签名。`,
    bussness_2: `即：业务参数签名<code>digest</code>=Base64(Md5(<code>J0086024071</code>+<code>A023DEEDCE52B0FD92A3EE1E9F74FD2B</code>+privateKey))`,
    headers_1: `示例：以取消订单为例：假设业务参数为  bizContent为<code>{"txlogisticId":"SA71398747473","orderType":2,"reason":"jiushixiangquxiaoyouruhe","customerCode":"J0086024071"}</code>,那么此时的header里面的签名digest等于<code>base64(md5(业务参数的Json+privateKey))</code>,`,
    headers_2: `即 <code>base64(md5({"txlogisticId": "SA71398747473", "orderType": 2, "reason": "jiushixiangquxiaoyouruhe", "customerCode": "J0086024071", "digest": "4hQ8qXNkuSJ8cIgJQDFFRA=="}+privateKey))</code>。`,
    headers_3: `注：<code>privateKey</code>为账号通过平台认证后自动分配`,
    一联模版: "一联模版",

    Introduction: "一、简介",
    sdk_two: "二、版本更新记录",
    sdk_3_title: "三、快速入门 安装API开放平台 SDK",
    sdk_4_title: "四、API-SDK目录结构",
    sdk_5_title: "五、直接使用JAR包步骤如下：",
    sdk_6_title: "六、SDK相关maven依赖",
    sdk_7_title: "七、创建JtExpressApi",
    sdk_8_title: "八、建议",
    Introduction_1: "Hi，您好，欢迎使用API开放平台。",
    Introduction_2:
      "本文档主要针对平台开发者，描述快递服务技术对接平台的相关技术内容。如果您对文档内容有任何疑问，可以联系平台运营解答疑问。",
    date: "日期",
    sdkVersion: "版本号",
    updata: "更新内容",
    updataInfo: "提供了调用开放平台接口的通用标准，辅助完成接口的签名",
    语言: "语言",
    最新版本: "最新版本",
    项目示例: "项目示例",
    开发环境: "开发环境",
    支持JAVA版本: "支持 JAVA版本：1.8+",
    支持PHP: "支持 PHP7.0及以上",
    签名相关类: "签名相关类",
    公用类: "公用类",
    异常相关类: "异常相关类",
    Http通信相关类: "Http通信相关类",
    开放平台api通用接口: "开放平台api通用接口",
    执行器接口: "执行器接口",
    sdk_5_txt: `<p>1.SDK压缩工具包由开放平台提供。</p>
    <p>2.将开放平台提供的"jt-openapi-sdk.zip"解压后，复制到工程文件夹中。</p>
    <p>3.点击 File -> Project Structure（快捷键 Ctrl + Alt + Shift + s），点击Project Structure界面左侧的“Modules。</p>
    <p>4.在 “Dependencies” 标签界面下，点击右边的 “+”号，选择第一个选项“JARs or directories...”，选择相应的jar包，点“OK”，jar包添加成功。</p>
    <p>5.具体接口的SDK调用方法可以下载‘示例实用项目.zip’进行参考。</p>`,
    sdk_6_txt:
      "SDK默认使用slf4j-api包进行日志输出;SDK默认使用fastjson进行json数据转换；SDK默认使用httpclient进行http数据传输。",
    sdk_7_txt: `<p>JtExpressApi是极兔开放平台api通用执行器,为使用极兔开放平台的开发人员提供了一系列的交互方法。</p>
    <p>用户可以参考如下代码新建一个JtExpressApi,初始化完成后建议单例使用,避免重复创建:</p>`,
    sdk_8_txt: `<p>如果你是用springboot框架来调用API开放平台-SDK相关接口,建议把JtExpressApi放到spring容器中进行管理,</p>
    <p>用户可以参考如下代码新建一个配置类:</p>`,

  // 系统级错误 (S*)
  S01: "非法的JSON格式【logistics_interface数据不符合JSON格式标准】",
  S02: "非法的数字签名【data_digest签名不正确，没有通过校验】",
  S03: "非法的物流公司【eccompanyid不正确，没有通过校验】",
  S04: "非法的通知类型【服务类型msg_type的值内容不在文档规定的范围类】",
  S05: "非法的通知内容【logistics_interface中内容格式不正确】",
  S06: "连接超时【创建订单时如果30秒内未获得响应认为是超时】",
  S07: "系统异常，请重试【数据库异常或其它系统错误，需联系开发处理】",
  S08:'非法的电商平台【eccompanyid错误】', // 修复重复问题：引用S07，避免字符串冗余
  S09: "没有任务数据返回【运费查询，快件跟踪查询当没有记录时返回】",
  S10: "订单号重复【在线下单接口txlogisticid订单号重复】",
  S11: "运单号重复【在线下单接口mailno运单号重复】",
  S12: "订单状态为GOT不能取消订单【订单更新接口，当订单已收件时，不能取消订单】",
  S13: "客户标识错误【在线下单接口客户标识customerid值错误，系统不存在】",
  S14: "运单号段错误【运单号段已使用完或还未发放运单号段】",
  S18: "仓库启用设置错误，请联系管理员【仓库启用设置错误，请联系管理员】",
  S101: "参数为空",
  S200: "IP禁止访问",
  S399: "系统异常！", 

  // 业务级错误 (B*)
  B300: "参数不能为空!",
  B301: "【customerid】货主编码不能为空!",
  B302: "【warehouseCode】仓库编码不能为空!",
  B303: "【goodsLong】货品长不能为空!",
  B304: "【goodsWidth】货品宽不能为空!",
  B305: "【goodsHeight】货品高不能为空!",
  B306: "【weight】货品重量不能为空!",
  B307: "【unitPrice】单价不能为空!",
  B308: "【currencyId】币种不正确!",
  B309: "【barcodes】条码集合不能为空!",
  B310: "【barcode】条码不能为空!",
  B311: "【electricityCapacity】带电容量不能为空!",
  B312: "【expirationType】有效期类型不能为空!",
  B313: "【expirationDate】有效期天数不能为空!",
  B314: "【unit】单位名称错误!",
  B315: "【itemCode】货品编码不能为空!",
  B316: "【itemName】商品名称不能为空!",
  B317: "【shortName】商品英文名称不能为空!",
  B318: "【quantityUM】单位数量不能为空!",
  B319: "【startPage】起始页不能为空!",
  B320: "【pageSize】页码不能为空!",
  B321: "【orderType】单据类型不正确!",
  B322: "【orderCode】订单编码不能为空!",
  B323: "【cancelReason】取消原因不能为空!",
  B324: "取消出库单失败，未查询到出库单！",
  B325: "取消出库单失败，出库单号为空！",
  B326: "【command】查询命令不能为空！",
  B327: "【serialnumber】出库单编码不能为空！",
  B328: "【txlogisticid】客户订单号不能为空",
  B329: "【ordertype】订单类型不能为空！",
  B330: "【sender.name】发件姓名不能为空！",
  B331: "【sender.mobile】发件手机不能为空！",
  B332: "【sender.phone】发件电话不能为空！",
  B333: "【sender.countrycode】发件国家代码不能为空！",
  B334: "【sender.prov】发件省份不能为空！",
  B335: "【sender.city】发件城市不能为空！",
  B336: "【sender.area】发件区域不能为空！",
  B337: "【sender.address】发件地址不能为空！",
  B338: "【sender】发件信息对象不能为空！",
  B339: "【receiver】收货信息对象不能为空！",
  B340: "【receiver.address】收货地址1不能为空！",
  B341: "【receiver.area】收货区县不能为空！",
  B342: "【receiver.city】收货城市不能为空！",
  B343: "【receiver.prov】收货省份不能为空！",
  B344: "【receiver.countrycode】收货国家不能为空！",
  B345: "【receiver.name】收货人名称不能为空！",
  B346: "【receiver.phone】收货人电话不能为空！",
  B347: "【receiver.mobile】收货人手机不能为空！",
  B348: "【transport】运输方式不能为空！",
  B349: "【itemsvalue】货款金额不能为空！",
  B350: "【pricecurrency】货款币种(代收)不能为空！",
  B351: "【routeid】路线ID不能为空！",
  B352: "【totalquantity】总件数不能为空！",
  B353: "【items】商品列表不能为空！",
  B354: "【items.itemvalue】标价不能为空且不能为0！",
  B355: "【carrier】承运商不能为空！",
  B356: "【mailno】运单号不能为空！",
  B357: "WMS请求异常！",
  B358: "商品信息校验接口请求异常！",
  B359: "【startdate】开始时间和【enddate】结束时间不能为空！",
  B360: "【entryOrderCode】入库单编码不能为空！",
  B361: "【expectStartTime】计划到达日期不能为空！",
  B362: "【quantity】计划入库数量不能为空！",
  B363: "【number】出库件数不能为空！",
  B364: "【label】面单URL和【mailno】运单号不能为空！",
  B365: "【label】面单URL非法！",
  B366: "【country】国家不能为空！",
  B367: "商品详情未维护！",
  B368: "【receiver.countrycode】国家编码不存在！",
  B369: "【mailno】运单号存在时，【label】面单URL不能为空！",
  B370: "【status】状态类型不正确!",
  B371: "【command】查询命令类型不正确！",
  B372: "开始时间不能大于结束时间!",
  B373: "时间格式不正确!",
  B374: "入库单信息不能为空!",
  B375: "【label】面单URL不能为空！",
  B376: "获取云仓域名失败！",
  B377: "调用WMS接口失败！",
  B378: "未找到该货主对应的仓库信息！",
  B379: "多个仓库创建商品失败！",
  B380: "多个仓库创建商品获取商品创建结果失败！",
  B381: "【expressBillFlag】输入值非法！",
  B3001: "参数不能为空",
  B3002: "【header】运单请求头不能为空!",
  B3003: "【details】运单请求详情不能为空!",
  B3004: "【erpOrderCode】erp订单号不能为空!",
  B3005: "【ShipFromName】寄件人姓名不能为空!",
  B3006: "【shipFromMobile】寄件人手机号不能为空!",
  B3007: "【shipFromPhoneNum】寄件人手机号不能为空!",
  B3008: "【shipFromCountry】寄件人国家不能为空!",
  B3009: "【shipFromState】寄件人省不能为空!",
  B3010: "【shipFromCity】寄件人城市不能为空!",
  B3011: "【shipFromAddress】寄件人详细地址不能为空!",
  B3012: "【ShipToName】收件人姓名不能为空!",
  B3013: "【shipToMobile】收件人手机号不能为空!",
  B3014: "【shipToPhoneNum】收件人手机号不能为空!",
  B3015: "【shipToCountry】收件人国家不能为空!",
  B3016: "【shipToState】收件人省不能为空!",
  B3017: "【shipToCity】收件人城市不能为空!",
  B3018: "【shipToAddress】收件人详细地址不能为空!",
  B3019: "【totalWeight】包裹总重量不能为空!",
  B3020: "【totalWeight】包裹总重量不能大于等于30kg!",
  B3021: "【totalQty】包裹总件数不能大于等于999件!",
  B3022: "【created】创建时间不能为空!",
  B3023: "【operateType】操作类型不能为空!",
  B3024: "【GoodsCategory】物品类型不能为空!"

  },
  controlPage: {
    审核状态: "审核状态",
    请选择国家: "请选择国家",
    请输入酋长国: "请输入酋长国",
    请输入区域: "请输入区域",
    公司详细地址: "公司详细地址",
    请输入社会信用代码: "请输入社会信用代码",
    请上传营业执照: "请上传营业执照",
    请输入法人身份证: "请输入法人身份证",
    身份证详细地址: "身份证详细地址",
    请选择证件类型: "请选择证件类型"
  },
  message: {},
  apiDoc: {
    搜索菜单: '搜索菜单',
    未找到匹配的菜单项: '未找到匹配的菜单项',
    极兔API简介: "极兔API简介",
    订单服务: "订单服务",
    创建订单: "创建订单",
    查询订单: "查询订单",
    取消订单: "取消订单",
    订单状态回传: "订单状态回传",
    退回件申请: "退回件申请",
    退换货接口: "退换货接口",
    散客寄件: "散客寄件",
    物流轨迹: "物流轨迹",
    物流轨迹查询: "物流轨迹查询",
    物流轨迹订阅: "物流轨迹订阅",
    物流轨迹回传: "物流轨迹回传",
    获取三段码: "获取三段码",
    API简介: "API简介",
    类型: "Type",
    ORDERCREATE_desc: "在线下单接口",
    ORDERCANCEL_desc: "取消订单接口",
    FREIGHTQUERY_desc: "运费查询接口",
    TRACKQUERY_desc: "跟踪查询接口",
    ROTAPRINT_desc: "电子面单打印接口",
    QUERYWAREHOUSE_desc: "退货库存查询接口",
    QUERYORDER_desc: "订单信息查询接口",
    QUERYORDERSTATUS_desc: "订单状态查询接口",
    OBTAINPROVCITYAREA_desc: "获取省市区基础资料接口",
    OBTAINPOSITION_desc: "获取留仓件资料接口",
    OBTAINDIFFICULT_desc: "获取疑难件资料接口",
    OBTAINTRANSPORT_desc: "获取运输方式资料接口",
    OBTAINROUTEDATA_desc: "获取路线基础资料接口",
    OBTAINWAREHOUSE_desc: "获取仓库信息资料接口",
    OBTAINPRODUCTTYPES_desc: "获取商品类型资料接口",
    SINGLEITEMCREATE_desc: "商品资料创建接口",
    ENTRYORDERCREATE_desc: "入库单创建接口",
    QUERYENTRYORDER_desc: "入库单查询接口",
    CREATESTOCKOUTORDER_desc: "出库单创建接口",
    STOCKOUTORDERQUERY_desc: "出库单查询接口",
    INVENTORYQUERY_desc: "库存查询接口",
    QUERYREPORT_desc: "查询服务",
    QUERYBILLINFO_desc: "客户账单查询接口",
    UPLOADINVOICE_desc: "订单发票上传",
    SORTCODE_desc: "分拣码查询",
    IMEIQUERY_desc: "IMEI查询",
    QUERYRATE_desc: "汇率查询",
    UPLOADFILE_desc: "上传称重图片",
    UPDATEORDERWEIGHT_desc: "二次修改预报重量",
    INVENTORYCALLBACK_desc: "库存变动回调",
    STOCKOUTORDERCALLBACK_desc: "出库单回传",
    
    IntroductionContent:
      "为了更好的服务广大客户，极兔云仓开放平台提供标准统一的接入API，为客户与平台直接实现数据的交互，提高双方的便利。本平台将接入的流程和步骤进行详细的描述，方便客户更快速准确的接入API平台。",
    对接流程: "对接流程",
    process_1:
      "1.查看API文档，调试测试环境接口服务，与具体的接口服务人员沟通解决问题。",
    process_2: "2.联调测试通过后，联系具体的接口服务人员，确认上线细节。",

    接入指南: "接入指南",
    复制代码: "复制代码",
    复制成功: "复制成功",
    复制失败: "复制失败",
    参考案列: "java 参考案列",
    title_1: "获取eccompanyid和秘钥key",
    text_11:
      "UAT环境可使用具体接口文档中的参考示例，生产环境需提前向技术支持获取",
    text_12: "例如申请到的eccompanyid和秘钥key如下：",
    text_13: "eccompanyid和秘钥key的获取方式：",
    title_2: "了解接口协议参数的具体含义",
    text_22: "msg_type消息类型有如下几种：",
    MSG类型: "msg_type类型",
    title_3: "根据JSON格式内容和秘钥key做签名",
    text_31:
      " 签名算法：先MD5签名得到32位小写，然后再做BASE64签名得到结果，字符编码使用UTF-8",
    text_32: `logistics_interface={"weight":"1","destAreaCode":"KALIDERES","sendSiteCode":"JAKARTA","feeType":"CHARGE","productType":"EZ"}`,
    text_33: "key=a620da4a08f8da77090b45ebea823f63",
    text_34:
      'data_digest = new String(Base64.encodeBase64(MD5Util.code32(logistics_interface + key, "UTF-8").getBytes("UTF-8")));',
    text_35:
      "上面得到的data_digest为：NjZhYWU3ZjIyZTZmZjJiYWJkNWE4NDc5ZDllZDRiMjA=",
    title_4: "发送http post请求",
    text_41: "http post请求需要将参数放入：",
    text_42: "form-data表单",
    text_43: "里面，再把数据传输过来。",
    text_44: "注意：切勿使用body json方式传参 否则会报S01错误",
    text_45: "请求样例",
    method_1:
      "1. 使用http协议表单提交的方式进行信息交互，字符编码默认统一采用UTF-8，数据格式：application/x-www-form-urlencoded;",
    method_2:
      "2. apiAccount和privateKey由平台提供； digest=base64(md5(业务参数的Json+privateKey))，注：先md5得到字节数组，再base64加密;",
    method_3:
      "3. 例如：base64(MD5({“age”:18,”gender”:”male”,”name”:”张三”}123456)) 如签名错误，可以对url进行编码然后发送请求。",
    method_4:
      "4. 字段类型约定：需要严格依据字段表格中给出的参数格式和大小进行开发。",
    method_5:
      "5. 字段解析约定：参数字段中的必选字段是每次调用接口时都要求必须传入的；",
    method_6: "6. 部分接口示例代码和sdk请参考示例代码、SDK文档。",
    在线文档: "在线文档",
    测试工具: "测试工具",
    失败: "失败",
    Headers签名失败: "Headers签名失败",
    内部调用异常: "内部调用异常",
    apiAccount为空: "apiAccount为空",
    digest为空: "digest为空",
    timestamp为空: "timestamp为空",
    系统错误: "系统错误",
    非法参数: "非法参数",
    面单模版查询: "面单模版查询",
    其他服务: "其他服务",
    三段码查询: "三段码查询",
    "面单模版查询（新）": "面单模版查询（新）",
    快件预报: "快件预报",
    快件预报删除: "快件预报删除",
    航空预报: "航空预报",
    预估运费查询: "预估运费查询",
    代收货款订阅: "代收货款订阅",
    代收货款回传: "代收货款回传",
    预约派送: "预约派送",
    出口国际件: "出口国际件",
    // ------------新加部分------------
    货品: "货品",
    创建货品: "创建货品",
    查询货品: "查询货品",
    单据: "单据",
    创建入库单: "创建入库单",
    查询入库单: "查询入库单",
    入库单状态回传: "入库单状态回传",
    创建出库单: "创建出库单",
    查询出库单: "查询出库单",
    出库单状态回传: "出库单状态回传",
    单据取消: "单据取消",
    基础资料: "基础资料",
    入库:"入库",
    出库:'出库',
    取消:"取消",
    全程跟踪:"全程跟踪",
    设备:'设备',
    // --------库存-------
    库存: "库存",
    库存查询: "库存查询",
    库存快照查询: "库存快照查询",
    库存异动回传: "库存异动回传",
    // ----------其他------------
    其他: "其他",
    查询备货仓库: "查询备货仓库",
    查询出库单轨迹: "查询出库单轨迹",
    合单预报: "合单预报",
    设备登录: "设备登录",
    称重设备上传重量: "称重设备上传重量"
  },
  apiDocDesc: {
    testUrl: "海外测试地址:",
    proUrl: "海外正式地址:",
    testUrlCn: "国内测试地址:",
    proUrlCn: "国内正式地址:",
    // -----创建货品
    itemDesc: "可通过此接口创建/修改货品信息",
    itemCodeDesc1: "货品编码xxxx",
    customeridDesc2: "货主编号",
    actionTypeDesc3: "add=新增资料 update=修改资料(不支持商品英文名称的修改)",
    warehouseCodeDesc4: "仓库编码（美国仓时为必填）",
    itemNameDesc5: "商品中文名称",
    shortNameDesc6: "商品英文名称",
    userDef1: "货品简称",
    parentCode: "货号",
    itemStyle: "规格",
    packingClass: "类别",
    netWeight:'净重',
    csDescNormal:"箱、包",
    csDesc:'箱显示名称',
    isFragile:'是否易碎品，0-否 1-是',
    isHazardous:'是否危险品，0-否 1-是',
    isLiquid:'是否液体，0-否 1-是',
    originAddress:'商品原产地',
    approvalNumber:'批准文号',
    sizeDesc7: "尺码",
    colorDesc8: "颜色",
    goodsLongDesc9: "最小单位长度，2位小数，0.01-9999",
    goodsWidthDesc10: "最小单位宽度，2位小数，0.01-9999",
    goodsHeightDesc11: "最小单位高度，2位小数，0.01-9999",
    weightDesc12: "最小单位重量，3位小数，0.001-9999",
    imageUrlDesc13: "图片URL",
    itemTypeDesc14:
      "商品类型（ZC=正常商品；BC=包材；OTHER=其它；只支持英文编码）支持配置，默认传 ZC",
    boxQtyDesc15: "箱包装数量",
    unitDesc16: "最小数量单位名",
    packageUnitDesc17: "包装单位",
    isElectricityDesc18: "是否带电，0-否 1-是",
    electricityCapacityDesc19:
      "带电容量(wh),当 是否带电为是(isElectricity = 1)时,该字段必填",
    expirationDesc20: "是否管理有效期，0=否 1=是",
    expirationDateDesc21: "有效期天数(条件必填：如果选择了有效期控制，则必填)",
    rejectLifecycleDesc22: "收货预警天数",
    lockupLifecycleDesc23: "禁售天数",
    adventLifecycleDesc24: "临期预警天数",
    isSNMgmtDesc25: "是否管理序列号， 0-否 1-是，默认为 否",
    SNMgmtDesc26:
      "序列号管理方式<br/>0=出入库<br/>1=仅出库<br/>条件必填，当是否管理序列号为是时，则必填",
    reserved1Desc27: "预留字段，定制化字段集合，内部字段按数据类型推送",
    "barcodes[]/barcode": "-",
    barcodeDesc28: "条码",
    quantityUMDesc28: "单位，EA-个/CS-箱/PL-托，默认EA，按英文编码推送",
    isBatchMgmtDesc29: "是否管理批次<br/>0-否 1-是 默认否",
    isLotMgmtDesc30: "是否管理批号， 0-否 1-是 默认否",
    supplierCodeDesc31: "供应商编码",
    supplierNameDesc32: "供应商名称",
    currencyIdDesc33: "币种，帮助中心查看枚举",
    tagPriceDesc34: "吊牌价",
    costPriceDesc35: "成本价",
    unitPriceDesc36: "零售价",
    purchasePriceDesc37: "采购价",
    brandCodeDesc38: "品牌编码",
    brandNameDesc39: "品牌名称",
    countryCodeDesc40:
      "国别/地区，同一SKU可能会在不同国家售卖，在不同国家的标价不同。不同吊牌价的SKU视为不同的SKU。",
    itemCodeDesc41: "商品编码",
    successDesc42: "是否成功",
    reasonDesc43: "错误编码",
    messageDesc44: "错误信息",
    // -------查询货品
    customeridDesc45: "客户标识",
    itemCodeDesc46: "商品编码",
    warehouseCodeDesc47: "仓库编码",
    startPageDesc48: "查询起始页",
    pageSizeDesc49: "分页条数",
    startdateDesc50: "商品创建开始时间",
    enddateDesc51: "商品创建结束时间",
    logisticprovideridDesc52: "物流公司代码",
    totalDesc53: "总条数",
    pagesDesc54: "总页数",
    pageDesc55: "当前页",
    pageSizeDesc56: "每页显示多少条",
    successDesc57: "是否成功",
    reasonDesc58: "失败原因",
    baseListDesc59: "数据列表",
    companyCodeDesc60: "货主编码",
    warehouseCodeDesc61: "仓库编码",
    skuDesc62: "客户商品编码",
    shortskuCodeDesc63: "仓库货品编码",
    skuStatusDesc64: "商品状态 启用 废弃 草稿 审核中",
    skuTypeDesc65: "商品类型 本国商品 跨境商品",
    chNameDesc66: "中文名称",
    enNameDesc67: "英文名称",
    colorDesc68: "颜色",
    productSizeDesc69: "尺寸",
    unitDesc70: "最小销售单位 个块只条根双对副支打箱袋件盒",
    isElectricityDesc71: "是否带电 0-N，1-Y",
    electricityCapacityDesc72: "带电容量 带电容量(wh),",
    goodsLongDesc73: "商品长度",
    goodsWidthDesc74: "商品宽度",
    goodsHeightDesc75: "商品高度",
    weightDesc76: "商品重量",
    isBaocaiDesc77: "是否包材 0-N，1-Y",
    isImeiDesc78: "是否管控IMEI 0-N，1-Y",
    outstorageControlDesc79: "出库复核管控 0-N，1-Y",
    putawayControlDesc80: "收货上架管控 0-N，1-Y",
    isDualImeiDesc81: "是否启用双IMEI 0-N，1-Y",
    isBatchDesc82: "是否进行批次管理 0-N，1-Y",
    lifeControlDesc83: "是否有效期管理 0-N，1-Y",
    validityPeriodDesc84: "有效期天数",
    boxQtyDesc85: "装箱数",
    packageUnitDesc86: "包装单位",
    exportCurrencyDesc87: "出口币种",
    exportUnitPriceDesc88: "出口单价",
    remarkDesc89: "备注",
    itemapiDesc: "通过此接口查询货品信息",
    // -----创建出库单
    createinboundDesc: "入库单创建",
    createinboundapiDesc: "通过此接口创建入库单",
    warehouseCodeDesc90: "仓库编码",
    entryOrderCodeDesc91: "客户订单号",
    customeridDesc92: "货主编号",
    erpOrderCodeDesc93: "来源订单号",
    sourceSystemDesc94: "订单来源系统",
    outBizNoDesc95: "外部业务单号",
    storerKeyDesc96: "经营公司代码",
    orderTypeDesc97: `入库单类型:<br/>
    CGRK-采购入库<br/>
    THRK-退货入库<br/>
    DBRK-调拨入库<br/>
    QTRK-其他入库`,
    expectStartTimeDesc98: "计划到达日期:YYYY-MM-DD",
    trackNoDesc99: "客退运单号",
    supplierCodeDesc100: "供应商编码",
    sourceWarehouseCodeDesc101: "出库仓库编码",
    sourceStoreCodeDesc102: "调出门店编号",
    remarkDesc103: "入库单备注",
    reserved1Desc104: "预留字段",
    itemsDesc105: "订单明细列表",
    LineNoDesc106: "入库单行号",
    itemCodeDesc107: "货品编码",
    quantityDesc108: "计划入库数量",
    inventoryTypeDesc109: "库存类型：ZP/CC，默认ZP",
    productDateDesc110: "生产日期：YYYY-MM-DD",
    expirationDateDesc111: "失效日期：YYYY-MM-DD",
    produceCodeDesc112: "生产批号",
    batchCodeDesc113: "批次编码",
    remarkDesc114: "备注",
    reserved1Desc115: "预留字段",
    responseitemsDesc116: "响应项",
    successDesc117: "是否成功",
    reasonDesc118: "错误编码",
    messageDesc119: "响应信息",
    entryOrderCodeDesc120: "客户订单号",
    entryOrderIdDesc121: "入库单号",
    // -----查询入库单
    queryinboundapiDesc: "通过此接口查询入库单",
    customeridDesc122: "客户编号",
    warehouseCodeDesc123: "仓库编码",
    entryOrderCodeDesc124: "入库单编码 多个入库单号用逗号隔开,command=1时必传",
    wmsOrderCodeDesc125: "WMS入库单号 多个入库单号用逗号隔开,command=3时必传",
    wmsOrderCodeDesc1255:'客退运单号 多个单号用逗号隔开,command=4时必传',
    commandDesc126:
      "查询命令：1.按入库订单号查询 2.按下单时间段查询 3.按WMS的入库单号查询 4.按客退运单号查询  5.按完成时间查询",
    startdateDesc127:
      "开始时间 (command=2、5时必传)，分页查询时间范围一个月",
    enddateDesc128:
      "结束时间 (command=2、5时必传)，分页查询时间范围一个月",
    batchesDesc129: "是否查询批次信息 0否 1是",
    ordertypeDesc130:
      "入库类型 CGRK-采购入库 THRK-退货入库 DBRK-调拨入库 QTRK-其他入库",
    statusDesc131:
      "入库状态 1.全部 2.未入库 3.取消入库 4.部分入库 5.全部入库 6.终止入库（部分入库完成） (默认查 1.全部)",
    successDesc132: "是否成功",
    reasonDesc133: "错误编码",
    warehouseCodeDesc134: "仓库编码",
    orderTypeDesc135:
      "入库类型 CGRK-采购入 THRK-退货入库DBRK-调拨入库QTRK-其他入库",
    orderTypeCodeDesc136: "入库类型",
    entryOrderCodeDesc137: "入库单号",
    wmsOrderCodeDesc138: "WMS入库单号",
    expectStartTimeDesc139: "预计入库时间",
    createdDesc140: "创建时间",
    closedAtDesc141: "关单时间",
    remarkDesc142: "备注",
    statusDesc143:
      "入库状态 2.未入库 3.取消入库 4.部分入库 5.全部入库 6.终止入库",
    itemsDesc144: "订单明细列表",
    LineNoDesc145: "行号",
    itemCodeDesc146: "商品编码",
    itemNameDesc147: "商品中文名称",
    shortNameDesc148: "商品英文名称",
    unitDesc149: "包装单位",
    quantityDesc150: "预期数量(计划入库数量)",
    actualQtyDesc151: "实收数量",
    batchesDesc152: "批次列表",
    actualQtyDesc153: "实收数量",
    inventoryTypeDesc154: "库存类型 ZP/CC，默认回传ZP",
    productDateDesc155: "生产日期",
    expireDateDesc156: "过期日期",
    produceCodeDesc157: "生产批号",
    batchCodeDesc158: "批次编码",
    // -------入库单回传
    inboundordercallbackapiDesc:
      "将接收入库单状态的回传接口提供给技术支持，后续入库单状态变更会自动推送至该接口",
    requestIdDesc159: "消息ID",
    warehouseCodeDesc160: "仓库编码",
    customerIdDesc161: "货主编号",
    storerKeyDesc162: "经营公司代码",
    entryOrderCodeDesc163: "客户订单号",
    entryOrderIdDesc164: "入库单号",
    entryOrderIdDesc1641: "客退运单号",
    wmsCreatedDesc1642: "是否WMS自建退货入库单: 0:否,1:是",
    deliveryOrderCodeDesc1643: "关联出库单号",
    platformNumberDesc1644: "平台单号",
    sourceSystemDesc165: "订单来源系统",
    outBizNoDesc166: "外部业务单号",
    orderTypeDesc167: "订单类型",
    confirmTypeDesc168:
      "确认类型 支持入库单多次收货(多次收货后确认时: 0:表示入库单最终状态确认，全量回传； 1:表示入库单中间状态确认，增量回传； 特殊情况:同一入库单;如果先收到0;后又收到1;允许修改收货的数量)",
    remarkDesc169: "备注",
    statusDesc170:
      "入库单状态 (NEW-未开始处理; ACCEPT-仓库接单; PARTFULFILLED-部分收货完成; FULFILLED-收货完成; EXCEPTION-异常; CANCELED-取消; 只传英文编码)",
    operateTimeDesc171:
      "操作时间(YYYY-MM-DD HH:MM:SS;当status=FULFILLED;operateTime为上架时间)",
    reserved1Desc172: "预留字段",
    orderLinesDesc173: "列表：订单明细",
    LineNoDesc174: "入库单行号",
    itemCodeDesc175: "货品编码",
    itemNameDesc176: "货品名称",
    quantityDesc177: "计划入库数量（最小单位数量）",
    actualQtyDesc178: "实收商品数量",
    inventoryTypeDesc179: "库存类型 ZP/CC,默认ZP",
    productDateDesc180: "生产日期",
    expireDateDesc181: "过期日期",
    produceCodeDesc182: "生产批号",
    batchCodeDesc183: "批次编码",
    reserved1Desc184: "预留字段",
    reserved1Desc1841: "唯一码列表",
    reserved1Desc18411:"货品唯一码",
    batchesDesc185: "批次列表",
    actualQtyDesc186:
      "实收商品数量 当前货品的最小单位实收数量，根据上架任务进行分批次回传/或整单回传。",
    inventoryTypeDesc187: "库存类型 ZP/CC,默认ZP",
    productDateDesc188: "生产日期",
    expireDateDesc189: "过期日期",
    produceCodeDesc190: "生产批号",
    batchCodeDesc191: "批次编码",
    successDesc192: "响应成功标识",
    codeDesc193: "响应code, 0: 成功, 其他:失败",
    request_idDesc194: "唯一请求id",
    messageDesc195: "响应结果描述",
    dataDesc196: "响应业务参数",
    // -------出库单创建
    outboundorderapiDesc: "通过此接口创建出库单",
    customeridDesc197: "货主编号",
    warehouseCodeDesc198: "仓库编码",
    eccompanyidDesc199: "货主ID",
    storerKeyDesc200: "经营公司代码",
    txlogisticidDesc201: "客户订单号",
    
    orderTypeDesc202:
      "订单类型：<br/>JYCK----2C销售出库<br/>BFCK----2C补发出库<br/>YPCK----2C样品出库<br/>QTCK----2C其他出库<br/>JITCK----2C唯品会出库<br/>HHCK----2C换货出库<br/>B2BXSCK----2B销售出库<br/>B2BDBCK----2B调拨出库<br/>CGTH-----2B采购退货<br/>XHCK-----2B销毁出库<br/>B2BQTCK-----2B其他出库<br/>B2BXNCK-----2B虚拟出库<br/>",
    sourceDesc203: "来源平台 电商平台列表见帮助中心，如无可传OTHER",
    platformNumberDesc204:
      "平台单号 电商平台的单号，如无可与客户订单号保持一致。",
    sourceSystemDesc205: "订单来源系统 客户业务系统：2B订单来源",
    outBizNoDesc206: "外部业务单号 客户业务系统单号",
    payTimeDesc207:
      "付款时间 电商平台订单的付款时间；时间格式（默认北京时间）2024-11-14 22:04:22",
    createOrderTimeDesc208:
      "下单时间 电商平台订单的下单时间；时间格式（默认北京时间）2024-11-14 22:04:22",
    requiredStockTimeDesc209:
      "要求出库时间 时间格式（默认北京时间）yyyy-MM-dd 或 yyyy-MM-dd HH:mm:ss",
    businessModeDesc210: "B2B/B2C标识 默认B2C",
    packageIdDesc1: "包裹号（TikTok平台订单必传）",
    senderDesc211: "发件人信息 如无特殊发件信息，此信息可不填",
    shippingProviderid:'物流服务商ID（TikTok平台订单必传）',
    skuId:'平台商品明细id（TikTok平台订单必传）',
    countrycodeDesc212:
      "发件国家代码 中国：CHN 印尼：IDN 马来：MYS 越南：VNM 菲律宾：PHL 泰国：THA 新加坡：SGP 柬埔寨：KHM",
    companyDesc213: "发件公司",
    nameDesc214: "发件姓名",
    postcodeDesc215: "发件邮编",
    mailboxDesc216: "发件邮箱",
    provDesc217: "发件省份",
    cityDesc218: "发件城市",
    areaDesc219: "发件区域",
    addressDesc2201: "短地址(当国家为沙特时，建议必填)",
    addressDesc220: "发件地址",
    address2Desc221: "发件地址2",
    mobileDesc222: "发件手机",
    phoneDesc223: "发件电话",
    receiverDesc224: "收件人信息",
    shipToDesc225: "门店编号 地址一（地址三选一必填，只能选择一种地址）",
    supplierCodeDesc226:
      "供应商编号 地址二（地址三选一必填，只能选择一种地址）",
    countrycodeDesc227:
      "收货国家 以下为地址三，（三选一必填，只能选择一种地址）",
    addressDesc228: "收货地址1",
    address2Desc229: "收货地址2",
    areaDesc230: "收货区县",
    cityDesc231: "收货城市",
    provDesc232: "收货省份",
    postcodeDesc233: "收货邮编",
    nameDesc234: "收货人名称",
    phoneDesc235: "收货人电话",
    mobileDesc236: "收货人手机",
    idNumberDesc237: "收件人身份证号",
    doorNoDesc238: "门牌号",
    idNumberUrlDesc239: "实名认证URL",
    transportModeDesc240:
      "配送方式 PTWL-平台物流 ZTJ-自提件 SJZL-商家自联快递 CPKD-仓配快递 CKPS-仓库配送",
    carrierDesc241:
      "物流公司编码 配送方式=平台物流/商家自联快递/仓配快递 时必填，编码查看帮助中心",
    routeidDesc242: "物流产品",
    mailnoDesc243: "承运单号 配送方式=平台物流/商家自联快递时必填",
    labelDesc244: "面单URL 配送方式=平台物流时必填",
    remarkDesc245: "买家备注",
    deliveryNoteDesc246: "卖家备注",
    isCodDesc247: "是否代收货款 0 否 1 是",
    itemsvalueDesc248: "代收货款金额 有值默认为代收货款方式",
    pricecurrencyDesc249: "货款币种(代收)，查看帮助中心",
    storeCodeDesc250: "店铺编码 平台店铺，用于参考平台店铺作业时效",
    storeNameDesc251: "店铺名称",
    isCrossBorderDesc252: "是否跨境订单，0 否 1 是",
    isPreSaleDesc253: "是否预售订单，0 否 1 是",
    reserved1Desc252: "预留字段",
    documentIdentificationDesc252: "单据标识 13 = Sameday",
    itemsDesc253: "商品信息列表",
    lineNoDesc254: "行号",
    itemCodeDesc255: "货品编码",
    numberDesc256: "计划数量 最小单位的总数量",
    itemvalueDesc257: "标价",
    inventoryTypeDesc258: "库存类型 ZP/CC,默认ZP",
    batchCodeDesc259: "批次编码",
    produceCodeDesc260: "批号",
    productDateDesc261: "生产日期 YYYY-MM-DD",
    remarkDesc262: "备注",
    isGiftDesc263: "是否赠品 0 否 1 是 默认否",
    reserved1Desc264: "预留字段",
    platformSkuCodeDesc: "平台商品编码",
    attachmentUrlDesc: "商品明细附件",
    responseitemsDesc265: "返回列表",
    txlogisticidDesc266: "客户订单号",
    mailnoDesc267: "运单号",
    billcodeDesc268: "运单号",
    deliveryOrderCodeDesc269: "出库单号",
    successDesc270: "是否成功",
    reasonDesc271: "错误编码",
    messageDesc272: "错误信息",
    filesDesc: "订单附件（巴西必填）",
    fileTypeDesc: "附件类型：INV=发票；RCT=回执；OTH=其他",
    fileUrlDesc: "附件地址，最大长度512",
    // -------出库单查询
    outboundorderqueryapiDesc: "此接口用于查询出库单",
    warehouseCodeDesc273: "仓库编码",
    serialnumberDesc274:
      "出库单编码：当command=1，传快递单号；当command=2，传erp单号txlogisticid；当command=3时，不必填；当command=5，传平台单号platformNumber",
    customeridDesc275: "货主编号",
    commandDesc276:
      "查询命令 1.按快递单号查询 2.按erp单号查询 3.按下单时间段查询 5.按平台单号查询",
    startdateDesc277:
      '开始时间 查询命令是3时，必传，最大范围30天 示例："2023-04-15 00:00:00"',
    enddateDesc278: '结束时间 查询命令是3时，必传，示例"2023-04-15 00:00:00"',
    pageNoDesc279: "页码 查询命令是3时，页码必传",
    pageSizeDesc280:
      "每页记录数 查询命令是3时，每页记录数必传，最大200条。超过200时直接打回",
    ordertypeDesc281:
      "出库类型：XSCK-销售出库；DBCK-调拨出库；QTCK-其他出库；TGYS-退供应商",
    statusDesc282:
      "出库状态 1 全部 2 待拣货 3 已出库 5 待处理  7 待复核 8 待称重 9 待出库 (默认查 1.全部)",
    countryDesc283:
      "所属国家 泰国：THA  菲律宾：PHL  马来：MYS  印尼：IDN  越南：VNM  中国：CHN  柬埔寨：KHM  新加坡：SGP  阿联酋：UAE  沙特：KSA  美国：USA  埃及：EGY  巴西：BRA  越南(新)：VNM_NEW",
    successDesc284: "是否成功",
    reasonDesc285: "错误编码",
    totalDesc286: "总条数 当command=1、2 时，返回单号总数量",
    startPageDesc287: "第几页 command=3时返回",
    pageSizeDesc288: "当前页数量 最大200条",
    orderListDesc289: "订单列表",
    customeridDesc290: "客户标识",
    txlogisticidDesc291: "客户订单号",
    mailnoDesc292: "运单编号",
    platformNumberDesc400: "平台单号",
    createdDesc293: "创建时间",
    sourceDesc294: "来源",
    orderstatusDesc295:
      "订单状态：待拣货、已出库、已取消、待处理、拣货中、待复核、待称重、待出库",
    warehouseCodeDesc296: "仓库编码",
    businessModeDesc297: "业务类型 默认 B2C",
    routeidDesc298: "路线ID",
    outboundtypeDesc299: "出库类型",
    transportDesc300: "运输方式",
    goodstypeDesc301: "货物类型",
    remarkDesc302: "备注",
    carrierDesc303: "承运人",
    endTrackingNoDesc304: "承运商单号",
    pickTypeDesc305: "揽收类型 1=上门取件 2=送货到仓",
    labelDesc306: "面单URL",
    stockTimeDesc307: "出库时间",
    senderDesc308: "发件信息对象",
    companyDesc309: "发件公司",
    nameDesc310: "发件姓名",
    postcodeDesc311: "发件邮编",
    mailboxDesc312: "发件邮箱",
    mobileDesc313: "发件手机",
    phoneDesc314: "发件电话",
    countrycodeDesc315: "发件国家代码",
    provDesc316: "发件省份",
    cityDesc317: "发件城市",
    areaDesc318: "发件区域",
    addressDesc319: "发件地址",
    receiverDesc320: "收件信息对象",
    companyDesc321: "收件公司",
    nameDesc322: "收件姓名",
    mobileDesc323: "收件电话",
    postcodeDesc324: "收件邮编",
    countryDesc325: "收件国家",
    provDesc326: "收件省份",
    cityDesc327: "收件城市",
    areaDesc328: "收件区域",
    addressDesc329: "收件地址",
    itemsDesc330: "商品信息列表",
    lineNoDesc331: "行号",
    itemCodeDesc332: "商品编码",
    itemNameDesc333: "商品名称",
    numberDesc334: "计划数量",
    quantityDesc335: "发货数量",
    snListDesc336: "唯一码列表",
    snDesc337: "货品唯一码",
    // -------出库单回传
    outboundordercallbackapiDesc:
      "将接收出库单回传接口提供给对接人员，后续出库单状态变更会自动推送至该接口",
    requestIdDesc338: "消息ID",
    warehouseCodeDesc339: "仓库编码",
    warehouseNameDesc340: "仓库名称",
    customerCodeDesc341: "货主编号",
    storerKeyDesc342: "经营公司代码",
    providerOrderIdDesc343: "客户订单号",
    deliveryOrderCodeDesc344: "出库单号",
    sourceDesc345: "来源平台",
    platformNumberDesc346: "平台单号",
    sourceSystemDesc347: "订单来源系统",
    outBizNoDesc348: "外部业务单号",
    scanTimeDesc349: "出库时间",
    logisticCodeDesc350: "物流服务商编码",
    trackingNumberDesc351: "运单号-母单号",
    reserved1Desc352: "预留字段",
    packagesDesc353: "包裹列表",
    logisticCodeDesc354: "物流服务商编码",
    logisticNameDesc355: "物流服务商名称",
    trackingNumberDesc356: "运单号",
    packageCodeDesc357: "包裹号",
    packagesitemsListDesc358: "包裹-商品子列表",
    itemCodeDesc359: "货品编号",
    quantityDesc360: "数量",
    packageMaterialListDesc361: "包裹-包材子列表",
    MaterialtypeDesc362: "包材编号",
    quantityDesc363: "包材数量：1",
    orderLinesDesc364: "订单明细列表",
    lineNoDesc365: "行号",
    itemCodeDesc366: "货品编码",
    numberDesc367: "计划数量：最小单位的总数量",
    actualQtyDesc368: "实际出库量：最小单位数量",
    inventoryTypeDesc369: "库存类型：ZP/CC,默认ZP",
    batchCodeDesc370: "批次编码",
    produceCodeDesc371: "批号",
    productDateDesc372: "生产日期：YYYY-MM-DD",
    remarkDesc373: "备注",
    reserved1Desc374: "预留字段",
    snListDesc375: "唯一码列表",
    snListDesc376: "货品唯一码",
    batchesDesc377: "批次列表",
    actualQtyDesc378: "实际出库量：最小单位数量",
    inventoryTypeDesc379: "库存类型：ZP/CC,默认ZP",
    batchCodeDesc380: "批次编号",
    productDateDesc381: "生产日期",
    expireDateDesc382: "过期日期",
    produceCodeDesc383: "生产批号",
    supplierCodeDesc384: "供应商编码",
    supplierNameDesc385: "供应商名称",
    successDesc386: "响应成功标识",
    codeDesc387: "响应code, 0: 成功, 其他:失败",
    request_idDesc388: "唯一请求id",
    messageDesc389: "响应结果描述",
    dataDesc390: "响应业务参数",
    // -------单据取消
    cancelorderapiDesc: "通过此接口取消出、入库单；根据单据类型区分出入库单",
    customeridDesc391: "货主编号，客户唯一标识",
    warehouseCodeDesc392: "仓库编码",
    orderTypeDesc393:
      "单据类型：<br/>CGRK-采购入库<br/>THRK-退货入库<br/>DBRK-调拨入库<br/>QTRK-其他入库<br/>XSCK-销售出库<br/>DBCK-调拨出库<br/>QTCK-其他出库<br/>TGYS-退供应商",
    orderCodeDesc394:
      "单据编号：当单据类型为 入库单类型时，此字段需要传入库单接口entryOrderCode字段的单号；当单据类型为 出库单类型时，此字段需要传出库单接口txlogisticid字段的单号。",
    cancelReasonDesc395: "取消原因",
    successDesc396: "是否成功",
    errorCodeDesc397: "错误编码",
    messageDesc398: "错误信息",

    // 库存查询
    inventoryqueryDesc: "库存查询",
    inventoryqueryapiDesc: "通过此接口获取货品的库存信息",
    warehouseCodeDesc399: "仓库编码",
    customeridDesc400: "货主编号",
    itemCodeDesc401:
      "货品编码：支持多个itemCode，英文逗号隔开；如不传itemCode，只会返回汇总数据；如传itemCode，会返回明细数据（最多传100个）",
    startPageDesc402: "页码",
    pageSizeDesc403: "每页记录数",
    successDesc404: "是否成功",
    reasonDesc405: "错误编码",
    messageDesc406: "响应信息",
    totalDesc407: "总条数",
    baseListDesc408: "数据列表",
    warehouseCodeDesc409: "仓库编码",
    itemCodeDesc410: "货品编码",
    abnormalCountDesc411: "异常品在库数量：正品以外的所有库存类型的汇总数据",
    totalQuantityDesc412: "库位库存总量：所有库存类型的汇总数据",
    lockQuantityDesc413:
      "锁定/待上架数量：移库过程或者盘点冻结等不可使用库存场景下的数量",
    saleQuantityDesc414:
      "正品可售数量：库位库存总量-订单池数量-分配数量-冻结数量",
    pickedQuantityDesc415: "拣货完成，未出库数量汇总",
    storeQuantityDesc416: "在仓数量：库位库存总量+已拣货数量",
    locationInventoryListDesc417: "明细列表",
    batchCodeDesc418: "批次编码",
    inventoryTypeDesc419: "库存类型",
    productDateDesc420: "生产日期",
    expireDateDesc421: "过期日期",
    produceCodeDesc422: "批号",
    lockQuantityDesc423: "锁定/上架数量",
    saleQuantityDesc424: "可用数量：库位库存总量-分配数量-冻结数量",
    // 库存快照查询
    InventorysnapshotqueryDesc: "库存快照查询",
    InventorysnapshotqueryapiDesc: "查询某一时间点的库存信息",
    warehouseCodeDesc425: "仓库编码",
    customeridDesc426: "货主编号",
    itemCodeDesc427: "货品编码：支持多个itemCode，英文逗号隔开（最多传100个）",
    snapshotDateDesc428: "归档日期",
    startPageDesc429: "页码",
    pageSizeDesc430: "每页记录数",
    successDesc431: "是否成功",
    reasonDesc432: "错误编码",
    messageDesc433: "响应信息",
    totalDesc434: "总条数",
    startPageDesc435: "页码",
    pageSizeDesc436: "每页记录数",
    baseListDesc437: "数据列表",
    warehouseCodeDesc438: "仓库编码",
    companyCodeDesc439: "货主编码",
    itemCodeDesc440: "货品编码",
    barcodesDesc441: "货品条码",
    inventoryTypeDesc442: "库存类型",
    snapshotDateDesc443: "归档日期",
    productDateDesc444: "生产日期",
    expireDateDesc445: "过期日期",
    batchCodeDesc446: "批次编码",
    produceCodeDesc447: "批号",
    inventoryAgeDesc448: "库龄",
    onHandQtyDesc449: "在库数量",
    availableQtyDesc450: "可用数量",
    // 库存异动回传
    InventorychangecallbackDesc: "库存异动回传",
    InventorychangecallbackapiDesc:
      "将接收库存异动回传接口提供给对接人员，后续库存发生变化将实时回传至该接口",
    customerIdDesc451: "货主编号",
    changeTimeDesc452: "变动时间",
    warehouseCodeDesc453: "仓库编码",
    orderCodeDesc454: "盘点单号/调整单号",
    reserved1Desc455: "预留字段",
    skuDesc456: "商品变动清单列表",
    itemCodeDesc457: "商品编码",
    beforeInventoryTypeDesc458: "变动前库存类型 ZP/CC，默认ZP",
    afterInventoryTypeDesc459: "变动后库存类型 ZP/CC，默认ZP",
    quantityDesc460:
      "变动数量：如果仅库存数量调整，则变动前后库存类型一致，正数表示库存增加，负数表示库存减少",
    batchCodeDesc461: "批次编码",
    produceCodeDesc462: "生产批号",
    remarkDesc463: "备注",
    reserved1Desc464: "预留字段",
    totalQuantityDesc465: "变动后总库存",
    requestIdDesc466: "消息ID",
    pushTimeDesc467:
      "推送时间:系统推送上游的时间，默认UTC+8 时间，传参时附带时区标志",
    remarkDesc468: "备注:调整原因+备注信息",
    successDesc469: "响应成功标识",
    codeDesc470: "响应code, 0: 成功, 其他:失败",
    request_idDesc471: "唯一请求id",
    messageDesc472: "响应结果描述",
    dataDesc473: "响应业务参数",
    // 其他--查询备货仓库
    warehousequeryDesc: "查询备货仓库",
    warehousequeryapiDesc: "查询货主关联的所有仓库",
    customeridDesc474: "客户标识",
    successDesc475: "是否成功",
    reasonDesc476: "失败原因",
    baseListDesc477: "数据列表",
    warehouseCodeDesc478: "仓库编码",
    warehouseNameDesc479: "仓库名称",
    // 出库单轨迹
    trackDesc: "查询出库单轨迹",
    trackapiDesc: "获取出库单的物流轨迹信息",
    warehouseCodeDesc480: "仓库编码",
    customeridDesc481: "客户标识",
    trackingNoListDesc482: "快递单号（最大不超过50条 ）",
    successDesc483: "是否成功",
    reasonDesc484: "失败原因",
    totalDesc485: "总条数",
    dataDesc486: "数据列表",
    trackingNoDesc487: "快递单号",
    tracesDesc488: "具体轨迹信息",
    statusDesc489: "状态",
    scanTypeDesc490: "扫描节点",
    scanTimeDesc491: "扫描时间",
    descDesc492: "轨迹描述",
    // 其他——合单预报
    CombinedorderforecastDesc: "合单预报",
    CombinedorderforecastapiDesc:
      "用于合单场景，通过此接口把待收的合单包裹推送至WMS，定制化接口，具体信息可咨询技术支持",
    warehouseCodeDesc493: "仓库编码",
    combinedOrderCodeDesc494: "合单单号",
    sourcePlatformDesc495: "来源平台",
    packageCodeDesc496: "包裹集合",
    packageCodeDesc497: "包裹号",
    forwardPackageCodeDesc498: "转寄快递单号",
    base64EncodeContentDesc499: "转寄打印链接",
    successDesc500: "是否成功,1为成功，其他为失败",
    messageDesc501: "错误信息",
    combinedOrderCodeDesc502: "合单单号",
    //设备登录
    DeviceloginDesc: "设备登录",
    DeviceloginapiDesc: "用于对接设备场景，支持设备登录鉴权",
    desc499:'报文格式',
    desc500: "设备类型",
    desc501: "设备厂商",
    desc502: "设备序列号",
    weightDesc506:'报文格式',
    weightDesc507:'设备类型',
    weightDesc508:'设备厂商',
    weightDesc509:'设备序列号',
    weightDesc510:"登录后返回client",
    weightDesc511:'登录后返回token',
    weightDesc512:'设备登录用户编码',
    usenameDesc503: "设备登录用户",
    passwordDesc504: "设备登录密码",
    codeDesc505: "响应码",
    msgDesc506: "响应信息",
    dataDesc507: "响应体",
    usernameDesc508: "设备登录用户名",
    tokenDesc509: "设备登录令牌",
    clientDesc510: "设备登录客户端",
    defaultWarehouseCodeDesc511: "设备登录默认仓库",
    traceIdDesc512: "追踪标识",
    // 其他——称重设备上传重量
    WeighingequipmentDesc: "称重设备上传重量",
    WeighingequipmentapiDesc:
      "用于称重设备对接场景，支持称重设备把单据的重量数据推送至WMS",
    referenceCodeDesc513: "快递单号",
    warehouseCodeDesc514: "仓库编码",
    weightDesc515: "重量：2位整数，1位小数，单位KG",
    codeDesc516: "响应码",
    msgDesc517: "响应信息"
  },
  onlineDoc: {
    requiredYes: "是",
    requiredNo: "否",
    logistics_interface_desc: "JSON格式内容",
    data_digest_desc: "签名结果",
    msg_type_desc: "消息类型",
    eccompanyid_desc: "消息提供者ID",
    地址: "地址：使用接入方提供的URL",
    请求方法: "请求方法：",
    数据类型: "数据类型：",
    响应类型: "响应类型：",
    接口说明: "接口说明",
    接口信息: "接口信息",
    参数描述: "参数描述",
    Headers: "Headers",
    请求参数: "请求参数",
    业务参数: "业务参数",
    sender类型说明: "sender类型说明",
    receiver类型说明: "receiver类型说明",
    items类型说明: "items类型说明",
    customsInfo类型说明: "customsInfo类型说明",
    details类型说明: "Type description",
    报文描述: "报文描述",
    响应参数: "响应参数",
    data类型说明: "data类型说明",
    请求示例: "请求示例",
    返回示例: "返回示例",
    错误代码: "错误代码",
    错误编码: "错误编码",
    错误描述: "错误描述",
    测试地址: "测试地址：",
    正式地址: "正式地址：",
    测试apiAccount: "测试apiAccount：",
    测试privateKey: "测试privateKey：",
    属性名: "属性名",
    变量名: "变量名",
    说明: "说明",
    属性类型: "属性类型",
    是否必填: "是否必填",
    示例: "示例",
    描述: "描述",
    OrderDescription_1:
      "与平台签约的客户，可通过此接口创建/修改订单。目前创建订单接口支持修改订单，即如果客户订单号（txlogisticId）已存在，且对应的订单未揽件，则直接修改已有订单。如果收件地址发生变更就重新获取最新的三段码/大头笔返回；",
    OrderDescription_2: "查询新增订单接口创建的订单",
    OrderDescription_3: "取消通过新增订单接口生成的订单",
    OrderDescription_4:
      "接入方在提供了物流状态回传相关信息并完成了下订单操作后，当订单相关的状态变化时，系统会根据接入方配置的推送账户主动推送物流信息。",
    OrderDescription_8: "通过地址查询对应的三段码信息",
    OrderDescription_5:
      "非网点签约客户可通过此接口创建散客订单。目前散客寄件接口支持修改订单，即如果客户订单号（txlogisticId）已存在，且对应的订单未揽件，则直接修改已有订单。可通过“实名制信息上传”接口上传寄件用户信息；",
    通过单号查询快件的轨迹信息: "通过单号查询快件的轨迹信息",
    OrderDescription_6: "用户通过接口可获取到电子面单的模版信息",
    OrderDescription_7: "用户通过接口可对已经取件的运单进行退件申请",
    OrderDescription_9: "退换货下单接口",
    trackDescription_1: "通过单号查询快件的轨迹信息",
    trackDescription_2: `向极兔订阅需推送物流轨迹的运单号 <br/> <strong>注意事项：需提供回传物流轨迹的URL</strong> `,
    trackDescription_2_1: `向极兔订阅需推送物流轨迹的运单号，注意事项：需提供回传物流轨迹的URL`,
    trackDescription_3:
      "接入方在提供了快递轨迹推送相关信息并完成了下订单操作后，当订单相关的运单轨迹变化时，系统会根据接入方配置的推送账户主动推送物流信息。",
    // 表单描述翻译
    接入方在平台的api账户标识: "接入方在平台的api账户标识",
    通过地址查询对应的三段码信息: "通过地址查询对应的三段码信息",
    签名字符串: "签名字符串",
    "时间戳，毫秒": "时间戳，毫秒",
    业务参数模块内json格式的string类型: "业务参数模块内json格式的string类型",
    "客户编码（联系出货网点提供）": "客户编码（联系出货网点提供）",
    sign: "签名，Base64(Md5(客户编号+密文+privateKey))，其中密文：MD5(明文密码+jadada236t2) 后大写",
    signnew:
      "1.MD5签名，Base64(Md5(客户编号+密文+privateKey))，其中密文：MD5(明文密码+jadada236t2) 后大写 <br />2.SHA256签名，Sha256(客户编号+密文+privateKey)，其中密文：Sha256(明文密码)",
    合作网点: "合作网点",
    "客户订单号（传客户自己系统的订单号）":
      "客户订单号（传客户自己系统的订单号）",
    ExpressType:
      "快件类型：仅支持<br/> EZ：standard（UAE)；<br/>EZKSA：standard（KSA)；<br/>Reverse: Reverse（KSA）；<br/>ReverseUAE: Reverse（UAE）<br/>SDD:Same Day（KSA）<br/>SDDUAE:Same Day（UAE）<br/>SCH: SCHEDULE（KSA）<br/>SCHUAE: SCHEDULE（UAE）",
    expressQueryType: "0.快递面单模板<br/>1.跨境件面单模板",
    OrderType: "订单类型（有客户编号为月结）<br/>1、 散客；<br/>2、月结；",
    服务类型: "服务类型 ：<br/>02 门店寄件 ；<br/> 01 上门取件",
    serviceTypeCode: "C01：国际件（International）<br/>C02：境内件（Domestic）",
    派送类型: "派送类型：<br/>03 门店自提；<br/>04 派送上门",
    paymentMethod: "支付方式：<br/>PP_PM(“寄付月结”)",
    寄件信息对象: "寄件信息对象",
    收件信息对象: "收件信息对象",
    LC_pick_up_start_time: "物流公司上门取货开始时间 yyyy-MM-dd HH:mm:ss",
    CLC_door_to_door_end_time:
      "客户物流公司上门取货结束时间 yyyy-MM-dd HH:mm:ss",
    itemtType:
      "物品类型（对应订单主表物品类型）:<p>ITN1 服饰</p>  <p>ITN2 文件</p>  <p>ITN3 食品</p>  <p>ITN4  其他</p>  <p>ITN5  数码产品</p>  <p>ITN6  生活用品</p>  <p>ITN7 易碎品</p>",
    Length: "长，cm",
    Width: "宽，cm",
    Height: "高，cm",
    volume: "体积",
    Weight: "重量，单位kg，范围0.01-30",
    包裹总件数: "包裹总件数",
    包裹总票数: "包裹总票数(<=999)",
    "代收货款金额 (数值型)": "代收货款金额 (数值型)",
    "代收货款金额 (数值型)1": "代收货款金额 (条件必填,数值型)",
    collectionPayment: "代收货款币别（默认本国币别，如：SAR、AED、USD、RMB）",
    collectionPayment1:
      "代收货款币别（条件必填,默认本国币别，如：SAR、AED、USD、RMB）",
    offerFee:
      "保价金额(数值型),单位,如:SAR、AED、USD、RMB,(0~99999999,支持4位小数)",
    保价费: "保价费",
    备注: "备注",
    商品信息列表: "商品信息列表",
    客户信息: "客户信息",
    寄件人姓名: "寄件人姓名",
    寄件公司: "寄件公司",
    寄件邮编: "寄件邮编",
    寄件邮箱: "寄件邮箱",
    SendingMobilePhone: "寄件手机（手机和电话二选一必填）",
    SendingPhoneNumber: "寄件电话（手机和电话二选一必填）",
    ThreeCharacterSending:
      "寄件国家三字码（如：阿联酋=UAE、中国=CHN、沙特=KSA）",
    寄件酋长国: "寄件省份",
    寄件区域: "寄件城市",
    区域1: "寄件区域",
    寄件街道: "寄件街道",
    ShippingDetailedAddress: "寄件详细地址（寄件省份+城市+详细地址）",
    寄件区号: "寄件区号",
    收件人姓名: "收件人姓名",
    收件人证件号码: "收件人证件号码",
    收件公司: "收件公司",
    收件邮编: "收件邮编",
    收件邮箱: "收件邮箱",
    ReceivingMobilephone: "收件手机（手机和电话二选一必填）",
    ReceivingPhoneNumber: "收件电话（手机和电话二选一必填）",
    ThreeCharacterRecipient:
      "收件国家三字码（如：阿联酋=UAE、中国=CHN、沙特=KSA）<p>收件地址需与客户所属地一致</p>",
    收件酋长国: "收件省份",
    收件区域: "收件城市",
    区域2: "收件区域",
    收件街道: "收件街道",
    ReceivingDetailedAddress: "收件详细地址（收件省份+城市+详细地址）",
    收件区号: "收件区号",
    物品类型:
      "物品类型: <p>ITN1 服饰</p>  <p>ITN2 文件</p>  <p>ITN3 食品</p>  <p>ITN4  其他</p>  <p>ITN5  数码产品</p>  <p>ITN6  生活用品</p>  <p>ITN7 易碎品</p>",
    物品名称: "物品名称",
    物品中文名称: "物品中文名称",
    物品英文名称: "物品英文名称",
    cases: "件数，≤1",
    "申报价值(数值型)": "申报价值(数值型) 单个物品价值",
    priceCurrency:
      "申报货款币别（默认本国币别，如：AED）） 单个订单申报币别不可不一致",
    物品描述: "物品描述",
    退换货: "1：退货 </br > 2：退换货",
    退货单单号: "退货单单号",
    换货单单号: "换货单单号(当 returnAndExchangeType 是 2 时返回)",
    商品URL: "商品URL",
    "货物数量 跨境件报关需要填写": "货物数量 跨境件报关需要填写",
    货物单位: "货物单位，如：个、台、本， 跨境件报关需要填写",
    原产地国别: "原产地国别， 跨境件报关需要填写",
    货物产品国检备案编号: "货物产品国检备案编号 跨境件报关需要填写",
    商品海关备案号: "商品海关备案号 跨境件报关需要填写",
    商品行邮税号: "商品行邮税号 跨境件报关需要填写",
    海关编码: "海关编码 跨境件报关需要填写",
    商品编号: "商品编号 跨境件报关需要填写",
    货物品牌: "货物品牌 跨境件报关需要填写",
    货物规格型号: "货物规格型号 跨境件报关需要填写",
    生产厂家: "生产厂家 跨境件报关需要填写",
    托寄物声明价值: "托寄物声明价值 跨境件报关需要填写",
    托寄物声明价值币别: "托寄物声明价值币别 跨境件报关需要填写",
    客户支付的运费: "客户支付的运费 跨境件报关需要填写",
    "返回码，见附录": "返回码，见附录",
    业务数据: "业务数据",
    集包地: "集包地",
    返回客户订单号: "返回客户订单号",
    订单创建时间: "订单创建时间 yyyy-MM-dd HH:mm:ss",
    三段码online: "三段码（获取到三段码优先返回三段码，无三段码返回大头笔）",
    参考总运费: "参考总运费（数值型）",
    查询命令:
      "查询命令 1.按客户订单编号查询   2.按运单编号查询（用运单号查订单状态）   3.按下单时间段查询（查订单）（按时间段查询返回不限制条数）  4.订单编号",
    command:
      "command=1 客户订单编号查询 ;command=2 运单编号暂时;command=4订单号（公司内部）支持200个; Command=1、2或3时必填",
    startDate:
      "开始时间(24小时制: yyyy-MM-dd HH:mm:ss)（command为3时必填）（客户下单时间）command = 3 时必填",
    endDate:
      "结束时间(24小时制: yyyy-MM-dd HH:mm:ss)（command为3时必填），时间范围最大7天command = 3 时必填",
    status:
      "状态（订单状态取下方状态表，筛选数据使用，默认全部）:<br/>已取消 104 ;<br/>已取件 103 ;<br/>已调派业务员 102 ;<br/>已调派网点 101 ;<br/>未调派 100",
    "command = 3 时必填": "command = 3 时必填",
    系统订单号: "系统订单号",
    "客户订单号-客户自己系统的订单号": "客户订单号    客户自己系统的订单号",
    订单状态:
      "订单状态 ：<br/>已取消 104 ；<br/>已取件 103 ；<br/>已调派业务员 102 ；<br/>已调派网点 101 ；<br/>未调派 100",
    订单类型: "订单类型  ：<br/>01散客 <br/> 02月结",
    三段码: "三段码",
    "客户编码（订单类型传2时，必填）": "客户编码（订单类型传2时，必填）",
    "订单类型  1（散客），2（协议客户）":
      "订单类型 <br/> 1（散客），<br/>2（协议客户）",
    取消原因: "取消原因",
    退件原因: "退件原因",
    运单号: "运单号",
    "更新订单时，必传": "更新订单时，必传",
    客户订单号: "客户订单号",
    operateType:
      "事件，客户填写“新增”则进行订单新增，；客户传“更新”，则进行订单更新<p>1 新增</p><p>2 修改</p>",
    客户订单编号: "客户订单编号",
    极兔运单编号: "极兔运单编号",
    "网点名称（“已调派业务员”回传）": "网点名称（“已调派业务员”回传）",
    "业务员名称（“已调派业务员”回传）": "业务员名称（“已调派业务员”回传）",
    "业务员联系方式（“已调派业务员”回传）":
      "业务员联系方式（“已调派业务员”回传）",
    极兔订单编号: "极兔订单编号",
    "重量（“已揽收”“已取件”时回传）": "重量（“已揽收”“已取件”时回传）",
    "订单取消原因（“已取消”时回传）": "订单取消原因（“已取消”时回传）",
    "状态(“已调派业务员”,“已揽收”，“已取件”，“已取消”)":
      "状态(“已调派业务员”,“已揽收”，“已取件”，“已取消”)",
    时间: "时间",
    承运商编码: "承运商编码",
    "业务员编码（联系出货网点提供，且采用网点编码签名）":
      "业务员编码（联系出货网点提供，且采用网点编码签名）",
    "签名，Base64(Md5(客户编码/业务员编码+密文+privateKey))，其中密文：MD5(明文密码/网点编码+jadada236t2) 后大写":
      "签名，Base64(Md5(客户编码/业务员编码+密文+privateKey))，其中密文：MD5(明文密码/网点编码+jadada236t2) 后大写",
    运单编号: "运单编号",
    "快件类型：EZ(标准快递)": "快件类型：EZ(标准快递)",
    "订单类型  1、散客；": "订单类型  1、散客；",
    "支付方式CC_CASH(“到付现结”);PP_CASH（“寄付现结”）":
      "支付方式CC_CASH(“到付现结”);PP_CASH（“寄付现结”）",
    "物流公司上门取货结束时间 yyyy-MM-dd HH:mm:ss":
      "物流公司上门取货结束时间 yyyy-MM-dd HH:mm:ss",
    "运单号，多个运单号以英文逗号隔开,目前先支持一次性最多查询30票运单":
      "运单号，多个运单号以英文逗号隔开,目前先支持一次性最多查询30票运单",
    运单轨迹详情: "运单轨迹详情",
    扫描时间: "扫描时间",
    轨迹描述: "轨迹描述",
    scanType:
      "扫描类型 <p>10：快件揽收</p> <p>50：发件扫描</p> <p>92：到件扫描</p> <p>90：中心到件</p> <p>94：派件扫描</p>  <p>100：快件签收</p> <p>110：问题件扫描</p> <p>172：退件扫描</p> <p>402：改地址扫描</p> <p>1001：退件签收</p> <p>301：国际件入仓</p> <p>302：国际航空到件</p> <p>303：国际航空发件</p> <p>304：报关扫描</p> <p>305：清关扫描</p>",
    scanTypeCode: "扫描类型code",
    扫描网点名称: "扫描网点名称",
    扫描网点ID: "扫描网点ID",
    业务员姓名: "业务员姓名",
    业务员联系方式: "业务员联系方式",
    扫描网点联系方式: "扫描网点联系方式",
    扫描网点省份: "扫描网点省份",
    扫描网点城市: "扫描网点城市",
    "扫描网点区/县": "扫描网点区/县",
    "上一站(到件)或下一站名称(发件)": "上一站(到件)或下一站名称(发件)",
    "下一站省份（发件扫描类型时提供）": "下一站省份（发件扫描类型时提供）",
    "下一站城市（发件扫描类型时提供）": "下一站城市（发件扫描类型时提供）",
    "下一站区/县（发件扫描类型时提供）": "下一站区/县（发件扫描类型时提供）",
    "签收图片（签收扫描时，展示该数据）": "签收图片（签收扫描时，展示该数据）",
    "电子签名（签收扫描时，展示该数据）": "电子签名（签收扫描时，展示该数据）",
    快递轨迹详情: "快递轨迹详情",
    订阅节点:
      "订阅节点：10&50&92&90&94&100&110&172&402&1001&301&302&303&304&305 <p>10：快件揽收</p> <p>50：发件扫描</p> <p>92：到件扫描</p> <p>90：中心到件</p> <p>94：派件扫描</p>  <p>100：快件签收</p> <p>110：问题件扫描</p> <p>172：退件扫描</p> <p>402：改地址扫描</p> <p>1001：退件签收</p> <p>301：国际件入仓</p> <p>302：国际航空到件</p> <p>303：国际航空发件</p> <p>304：报关扫描</p> <p>305：清关扫描</p>",
    数组: "数组",
    "明文密码:H5CD3zE6": "明文密码:H5CD3zE6",
    电子面单标签: "电子面单标签",
    电子面单链接: "电子面单链接",
    平台名称: "平台名称",
    客户账户: "客户账户",
    isUnpackEnabled: "是否允许客户开箱验视<p>0 否</p><p>1 是</p>",
    needLogo: "0: 需要 <br /> 1:不需要",
    寄件经度: "寄件经度",
    寄件纬度: "寄件纬度",
    收件经度: "收件经度",
    收件纬度: "收件纬度",
    "经度（在问题件扫描时回传）": "经度（在问题件扫描时回传）",
    "纬度（在问题件扫描时回传）": "纬度（在问题件扫描时回传）",
    "OTP验证码（签收扫描类型时提供）": "OTP验证码（签收扫描类型时提供）",
    商户号: "商户号",
    快件预报接口:
      "用于跨境客户，同步发货批次中快件信息，例如：航空/陆运主单信息、包号、快件单号信息等。在库区完成货物分拣，打包称重、航空订舱后，通过接口回传相关批次内的货物信息。",
    航空主单号: "航空主单号",
    托盘号: "托盘号",
    包号: "包号",
    包重量: "包重量",
    封包时间: "封包时间",
    包列表: "包列表",
    航空预报接口:
      "用于跨境客户，同步发货批次的航空、陆运、海运信息。再完成订舱获取到承运商的班次信息后，通过接口同步末端J&T Express，方便末端即使安排清关、尾派货。",
    航空主单号陆运主单号: "航空主单号/陆运主单号",
    航班号: "航班号",
    航班日期: "航班日期",
    航班预计起飞时间: "航班预计起飞时间",
    航班预计到达时间: "航班预计到达时间",
    航班实际起飞时间: "航班实际起飞时间",
    航班实际到达时间: "航班实际到达时间",
    运送重量: "运送重量",
    起始地国家: "起始地国家 <br /> 1. KSA <br /> 2. UAE <br /> 3. CHN",
    目的地国家: "目的地国家 <br /> 1. KSA <br /> 2. UAE <br /> 3. CHN",
    起始地机场: "起始地机场",
    目的地机场: "目的地机场",
    目的港: "目的港 <br /> DMM <br /> JED <br /> RUH <br />DXB",
    删除类型:
      "删除类型 <br /> PALLET：托盘 <br /> PACKAGE_INFO ：包信息 <br /> ORDER：订单",
    "批次号（快件预报删除）": "批次号（type为PALLET 、PACKAGE_INFO必填）",
    "托盘号（快件预报删除）": "托盘号（type为PALLET、PACKAGE_INFO 必填）",
    "包号（快件预报删除）": "包号（type为PACKAGE_INFO 必填）",
    "运单号（快件预报删除）": "运单号（type为ORDER 必填）",
    快件预报删除接口: "使用该接口删除快件预报中提交的信息",
    托盘列表: "托盘列表",
    订单列表: "订单列表",
    签名类型: "签名类型 1.MD5(默认) 2.SHA256",
    "问题件图片（在问题件扫描时提供）": "问题件图片（在问题件扫描时提供）",
    问题件二级编码: "问题件二级编码",
    预估运费查询: "预估运费查询",
    预估运费查询说明: "通过收寄件地址及物品信息预估运费",
    "⻓，cm": "⻓，cm",
    "宽，cm": "宽，cm",
    "⾼，cm": "⾼，cm",
    重量: "重量（正数），单位kg，范围0.01-30，为空默认0.02",
    "运费总价（单位：元），保留两位⼩数": "运费总价（单位：元），保留两位⼩数",
    subscribeDesc: "开放平台⽤户根据apiaccount订阅需要接收代收货款的客户编码",
    subscribeOtherDesc:
      "推送财务结算的代收货款内容给到客户，客户需要在开放平台配置回传地址。",
    登记时间: "登记时间",
    订单流水号: "订单流水号",
    返款进度: "返款进度\n1:待申请\n2:待审核\n3:待返款\n4:已返款",
    "应付客户货款⾦额": "应付客户货款⾦额",
    总运单票数: "总运单票数",
    运单列表信息: "运单列表信息",
    "到件图片（到件扫描时，展示该数据，多张图片以逗号分割）":
      "到件图片（到件扫描时，展示该数据，多张图片以逗号分割）",
    预约派送日期: "预约派送日期",
    预约派送时间段: "预约派送时间段",
    国家三字码: "国家三字码",
    省份: "省份",
    城市: "城市",
    区域: "区域",
    详细地址: "详细地址",
    "true 成功 false 失败": "true 成功 false 失败",
    客户可通过此接口进行预约派送: "客户可通过此接口进行预约派送",
    OrderDescription_10: "与平台签约的客户，可通过此接口创建出口国际件订单。",
    "业务参数，各接口的入参json报文": "业务参数，各接口的入参json报文",
    "默认C03-出国国际件": "默认C03-出国国际件",
    CharacterSending: "寄件国家二/三字码(阿联酋=AE/UAE)-只支持阿联酋",
    CharacterRecipient: "收件国家二字码",
    数量: "数量",
    purposeOfShipment:
      "发货目的（如1、2、3）<br/>1映射Gift<br/>2映射Personal not for sale<br/>3映射General Items",
    原产地: "原产地",
    internationalExportExpressType: "仅支持ExportUAE"
  },
  apiTestDoc: {
    接口说明: "接口说明",
    Headers: "Headers",
    Body: "Body",
    Response: "Response",
    错误代码: "错误代码",
    错误编码: "错误编码",
    错误描述: "错误描述",
    请求头Headers参数: "请求头Headers参数",
    不能为空: "不能为空",
    参数: "参数",
    业务参数签名失败: "业务参数签名失败",
    修改订单失败: "修改订单失败",
    区域不合法: "区域不合法",
    城市不合法: "城市不合法",
    省份不合法: "省份不合法",
    查不到数据: "查不到数据",
    下单失败: "下单失败",
    发件人信息不全: "发件人信息不全",
    "订单重复,无需重复下单！": "订单重复,无需重复下单！",
    收件人信息不全: "收件人信息不全",
    电话号码不能为空: "电话号码不能为空",
    地址信息不全: "地址信息不全",
    "请检查订单类型、服务类型、派送类型、物品类型、快件类型、结算方式是否合法":
      "请检查订单类型、服务类型、派送类型、物品类型、快件类型、结算方式是否合法",
    "请检查服务类型是否合法值为 01或 02": "请检查服务类型是否合法值为 01或 02",
    上门服务时间信息不全: "上门服务时间信息不全",
    重量信息不合法: "重量信息不合法",
    物品信息不全: "物品信息不全",
    物品名称不全: "物品名称不全",
    物品类型不全: "物品类型不全",
    "客户订单号已存在,无法下单！": "客户订单号已存在,无法下单！",
    姓名信息非法: "姓名信息非法",
    公司信息过长: "公司信息过长",
    联系信息过长: "联系信息过长",
    邮编或邮箱信息非法: "邮编或邮箱信息非法",
    价格信息非法: "价格信息非法",
    "备注、描述、链接信息非法": "备注、描述、链接信息非法",
    地址信息过长: "地址信息过长",
    街道信息过长: "街道信息过长",
    包裹总件数无效: "包裹总件数无效",
    暂未开通代收货款业务: "暂未开通代收货款业务",
    "支付方式不匹配,PP_CASH,CC_CASH,PP_MM":
      "支付方式不匹配,PP_CASH,CC_CASH,PP_MM",
    已取件状态不可修改: "已取件状态不可修改",
    已取消状态不可修改: "已取消状态不可修改",
    "更新订单失败，请稍后重试！": "更新订单失败，请稍后重试！",
    始发地信息不全: "始发地信息不全",
    收货地信息不全: "收货地信息不全",
    暂未开通保价服务: "暂未开通保价服务",
    保价金额需大于等于0: "保价金额需大于等于0",
    时间范围非法: "时间范围非法",
    页码非法: "页码非法",
    超过数据限制: "超过数据限制",
    客户订单号不能为空或过长: "客户订单号不能为空或过长",
    取消原因不能为空: "取消原因不能为空",
    运单号非法: "运单号非法",
    运单号个数超过30: "运单号个数超过30",
    运单号个数超过1000: "运单号个数超过1000",
    物品数量非法: "物品数量非法",
    非法金额: "非法金额",
    必填参数为空: "必填参数为空",
    "总数量不能超过 999": "总数量不能超过 999",
    客户编码不合法: "客户编码不合法",
    发件人信息不完整: "发件人信息不完整",
    收件人信息不完整: "收件人信息不完整",
    手机号码长度错误: "手机号码长度错误",
    请填写正确的寄件省份: "请填写正确的寄件省份",
    COD代收货款不能超过3万: "COD代收货款不能超过3万",
    货到付款金额不能小于: "货到付款金额不能小于 0.01",
    货品类型信息不完整: "货品类型信息不完整",
    "请检查服务类型是否合法（仅支持 01 或 02）":
      "请检查服务类型是否合法（仅支持 01 或 02）",
    请填写正确的派送类型: "请填写正确的派送类型",
    请填写正确的运输类型: "请填写正确的运输类型",
    快递类型错误: "快递类型错误",
    服务类型代码校验失败: "服务类型代码校验失败",
    仓库标识错误: "仓库标识错误",
    条码不能为空: "条码不能为空",
    商品编码不能为空: "商品编码不能为空",
    "SKU 编码不能为空": "SKU 编码不能为空",
    参数长度超过最大限制: "参数长度超过最大限制",
    "运费不能小于 0": "运费不能小于 0",
    运费不合法: "运费不合法",
    收货地址与客户所在位置不一致: "收货地址与客户所在位置不一致",
    未找到收件人国家: "未找到收件人国家",
    币种不合法: "币种不合法",
    订单申报币种不匹配: "订单申报币种不匹配",
    寄件国家编码或者名称不能为空: "寄件国家编码或者名称不能为空",
    高价值包裹必须填写收件人证件号码: "高价值包裹必须填写收件人证件号码",
    订单申报币种: "订单申报币种",
    货物寄送目的填写错误: "货物寄送目的填写错误"
  },
  ...lang
};

export default messages;
